
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util'
	import AbpBase from '@/lib/abpbase'
	import LanguageSwitch from '../components/language-switch.vue'

	@Component({
		components: {
			LanguageSwitch
		}
	})
	export default class NewsDetail extends AbpBase {
		iosUrl: string = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/ios/manifest.plist';
		androidUrl: string = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/android/app-release.apk';
		isInWeixin: boolean = false;
		isInIos: boolean = false;
		isTest: boolean = false;
		openApp: boolean = false;

		accountActive: Object = {
			en: "Account Activate",
			chs: "账户激活"
		};
		openAppDesc: Object = {
			en: "Open App",
			chs: "打开APP"
		};
		changeLang: Object = {
			en: "Language",
			chs: "语言"
		};
		lang: string = "zh-Hans";
		localizationList : Array<any> = [];
		
		L(name) {
		
			var n = '';
		
		
			
				var that = this;
				var findindex = that.localizationList.findIndex(e => {
					return e.name == name
				})
				if (findindex > -1) {
					n = that.localizationList[findindex].value
				} else {
					n = name;
				}
		
			
			
		
			return n;
		
		}



		async created() {

			this.isInWeixin = this.isWeiXin();
			this.isInIos = this.isIos();
			this.isTest = this.$route.query.istest as any == "1";
			// if (this.isTest) {
			// 	this.iosUrl = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/ios_test/manifest.plist';
			// 	this.androidUrl = 'https://yfpogis-appdown.oss-cn-shanghai.aliyuncs.com/download/android_test/app-release.apk';
			// }
			// this.openApp = (this.$route.query.open as any) == "1";
			// if (!this.isInWeixin && this.openApp) {
			// 	location.href = 'gis://yfpo.com';
			// }

			if (abp.utils.getCookieValue("Abp.Localization.CultureName") == "en") {
				this.lang = 'en';
			} else {
				this.lang = 'zh-Hans';
			}
			this.loadLocalization();
		}
 

		changLang() {
			if (this.lang == "en") {
				this.lang = 'zh-Hans';
				abp.utils.setCookieValue(
					"Abp.Localization.CultureName",
					'zh-Hans',
					new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
					abp.appPath
				);
			} else {
				this.lang = 'en';
				abp.utils.setCookieValue(
					"Abp.Localization.CultureName",
					'en',
					new Date(new Date().getTime() + 5 * 365 * 86400000), //5 year
					abp.appPath
				);
			}
					
			if (abp.utils.getCookieValue("Abp.Localization.CultureName") == "en") {
				this.lang = 'en';
			} else {
				this.lang = 'zh-Hans';
			}
			
			this.loadLocalization();
		}
		loadLocalization() {
			var that = this;
		
			this.$store.dispatch({
				type: 'app/getLocalizations',
				data: this.lang
			}).then((res) => {
				that.localizationList = res;
			});
		
		}
		formattedText(rawText) {
			// 替换换行符为<br>
			let textWithNewLines = rawText.replace(/\n/g, '<br>');
			// 替换多个空格为一个空格
			let textWithoutMultipleSpaces = textWithNewLines.replace(/\s+/g, ' ');
			return textWithoutMultipleSpaces;
		}


		goAccountActivation() {
			if (this.isTest) {
				window.open('#/accountactivation?istest=1&t=' + Math.round(Math.random() * 10));
			} else {
				window.open('#/accountactivation?t=' + Math.round(Math.random() * 10));
			}

		}
		download() {
			if (this.isIos()) {
				//	alert('企业级应用需要您授权信任才正常使用，请按流程操作。');

				location.href = "itms-services://?action=download-manifest&url=" + this.iosUrl;
			} else {
				location.href = this.androidUrl + "?time" + new Date().getTime();
			}
		}
		isWeiXin() {
			var ua = navigator.userAgent.toLowerCase() as any;
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true; // 是微信端
			} else {
				return false;
			}
		}
		isAndroid() {
			var u = navigator.userAgent.toLowerCase();
			if (u.indexOf("android") > -1 || u.indexOf("linux") > -1) {
				if ((window as any).ShowFitness !== undefined) return true;
			}
			return false;
		}

		isIos() {
			var u = navigator.userAgent.toLowerCase();
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}

	};
